export function eventFormFilters() {
    const form = document.querySelector('form#filter') as HTMLFormElement;
    if (!form) return;

    const h1 = document.querySelector('h1');
    const locationFilter = h1?.textContent?.trim() || 'na';

    form.addEventListener('submit', () => {
        const formData = new FormData(form);

        formData.forEach((value, name) => {
            const fieldset = form.querySelector(`input[name="${name}"]`)?.closest('fieldset');
            const legend = fieldset?.querySelector('legend')?.textContent?.trim() || name;
            const option = form.querySelector(`input[name="${name}"]:checked`)?.closest('.option');
            const valueName = option?.querySelector('label')?.textContent?.trim() || value.toString();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                emplacementFiltre: locationFilter,
                nomFiltre: legend,
                valeurFiltre: valueName,
                event: 'filtre'
            });
        });
    });
}
